const HIGHLIGHT_ATTR = 'data-engramiq-highlight';

export { HIGHLIGHT_ATTR };

export function clearHighlights() {
  document.querySelectorAll(`[${HIGHLIGHT_ATTR}]`).forEach((el) => {
    (el as HTMLElement).style.backgroundColor = '';
    (el as HTMLElement).style.borderRadius = '';
    (el as HTMLElement).style.opacity = '';
    el.removeAttribute(HIGHLIGHT_ATTR);
  });
}

export function highlightExcerptOnPage(
  pageContainer: Element,
  excerpt: string,
  scroll = true,
  color = 'rgba(23, 196, 128, 0.55)',
): boolean {
  const textLayer = pageContainer.querySelector('.rpv-core__text-layer')
    ?? pageContainer.querySelector('[data-testid^="core__text-layer"]');
  if (!textLayer) return false;

  let spans = textLayer.querySelectorAll('.rpv-core__text-layer-text');
  if (spans.length === 0) spans = textLayer.querySelectorAll('span');
  if (spans.length === 0) return false;

  let fullText = '';
  const spanInfos: { span: HTMLSpanElement; start: number; end: number }[] = [];
  spans.forEach((span) => {
    const text = span.textContent || '';
    spanInfos.push({ span: span as HTMLSpanElement, start: fullText.length, end: fullText.length + text.length });
    fullText += text;
  });

  const searchText = excerpt.trim().slice(0, 120).toLowerCase();
  const normalised = searchText.replace(/\s+/g, ' ');
  const normalisedFull = fullText.toLowerCase().replace(/\s+/g, ' ');

  let matchIndex = normalisedFull.indexOf(normalised);

  if (matchIndex === -1 && normalised.length > 60) {
    matchIndex = normalisedFull.indexOf(normalised.slice(0, 60));
  }
  if (matchIndex === -1 && normalised.length > 30) {
    matchIndex = normalisedFull.indexOf(normalised.slice(0, 30));
  }

  if (matchIndex === -1) return false;

  let normIdx = 0;
  let origStart = -1;
  let origEnd = -1;
  const lowerFull = fullText.toLowerCase();
  for (let i = 0; i < lowerFull.length; i++) {
    if (/\s/.test(lowerFull[i]) && i > 0 && /\s/.test(lowerFull[i - 1])) continue;

    if (normIdx === matchIndex && origStart === -1) origStart = i;
    if (normIdx === matchIndex + normalised.length) {
      origEnd = i;
      break;
    }
    normIdx++;
  }
  if (origStart === -1) return false;
  if (origEnd === -1) origEnd = fullText.length;

  let highlighted = false;
  for (const { span, start, end } of spanInfos) {
    if (end > origStart && start < origEnd) {
      span.style.backgroundColor = color;
      span.style.borderRadius = '2px';
      span.style.opacity = '1';
      span.setAttribute(HIGHLIGHT_ATTR, 'true');
      highlighted = true;
    }
  }

  if (highlighted && scroll) {
    const first = textLayer.querySelector(`[${HIGHLIGHT_ATTR}]`);
    first?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  return highlighted;
}
